'use es6';

export const MODULE_VALIDATION_HELP_TEXT_EXCEEDS_LIMIT = 'MODULE_VALIDATION_HELP_TEXT_EXCEEDS_LIMIT';